/**
 * Expert mode layout: every block keeps its usual width and each tariff gets
 * its paste panel (360px wide, 1rem away) on its right. From xl, the form
 * column grows by that much and its blocks keep the usual width, except the
 * paste hosts (blocks holding tariffs with their panels) which span it all.
 * Below xl there is no room: the panel goes above its tariff, see
 * `WithExcelPastePanel`.
 */

/** Marks a block holding paste panels, so it spans the widened column. */
export const PASTE_HOST_PROPS = { 'data-excel-paste-host': '' };

/** Usual width of a form column, as in `StyledFormSection`. */
export const FORM_COLUMN_WIDTH = 'lg:w-1/2 2xl:w-1/3';

/** Keeps the children that are not paste hosts at the usual width. */
export const EXPERT_CHILDREN_WIDTH =
  'xl:*:not-data-excel-paste-host:max-w-[calc(100%-376px)]';

/** Form column widened for the paste panels in Expert mode. */
export const EXPERT_FORM_COLUMN_WIDTH = `min-w-0 lg:w-1/2 xl:w-[calc(50%+376px)] 2xl:w-[calc(100%/3+376px)] ${EXPERT_CHILDREN_WIDTH}`;
